import { Component, OnInit } from '@angular/core';
import { IdService } from '../id/id.service';

@Component({
  selector: 'app-rotulo',
  templateUrl: './rotulo.component.html',
  styleUrls: ['./rotulo.component.css']
})
export class RotuloComponent implements OnInit {

  public tituloIdOrigemId: string = 'Id';

  constructor(private idService: IdService) {}

  ngOnInit(): void {
    this.updateTitulo();
    this.idService.mostrarOrigemId$.subscribe(() => this.updateTitulo());
  }

  onDoubleClick(): void {
    this.idService.alterarVisualizacao();
  }

  private updateTitulo(): void {
    this.tituloIdOrigemId = this.idService.mostrarOrigemId ? 'Origem Id' : 'Id';
  }
}
